export function getNavLinks(t: (key: string) => string) {
  return [
    { label: t('home'), href: '/' },
    { label: t('tools'), href: '/tools' },
    { label: t('removeBackground'), href: '/remove-background' },
    { label: t('compressPdf'), href: '/compress-pdf' },
    { label: t('compressImage'), href: '/compress-image' },
    { label: t('compressVideo'), href: '/compress-video' },
    { label: t('aboutUs'), href: '/about' },
    { label: t('contact'), href: '/contact' },
  ]
}

export function getFooterLinks(t: (key: string) => string) {
  return {
    tools: [
      { label: t('pdfConverter'), href: '/compress-pdf' },
      { label: t('videoConverter'), href: '/compress-video' },
      { label: t('imageCompressor'), href: '/compress-image' },
      { label: t('audioConverter'), href: '/audio-converter' },
    ],
    resources: [
      { label: t('blog'), href: '/blog' },
    ],
    company: [
      { label: t('home'), href: '/' },
      { label: t('aboutUs'), href: '/about' },
      { label: t('contact'), href: '/contact' },
    ],
    legal: [
      { label: t('termsOfUse'), href: '/terms' },
      { label: t('privacy'), href: '/privacy' },
      { label: t('cookies'), href: '/cookies' },
    ],
  }
}
